import { Box, Typography } from "@mui/material";
import { accessDenied } from "../assets";

const PermissionDeniedPage = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "80vh",
      }}
    >
      <Box sx={{ width: "500px" }}>
        <img
          src={accessDenied}
          alt="permission_denied"
          style={{ width: "100%", height: "100%" }}
        />
      </Box>
      <Typography variant="h1">Permission Denied</Typography>
      <Typography variant="body1">
        Sorry, You do not have permission to view this page
      </Typography>
    </Box>
  );
};

export default PermissionDeniedPage;
